import { postRequest } from "./postRequest";

const CATEGORY_API = process.env.REACT_APP_GET_DETAILS_API

 console.log(CATEGORY_API)
export const postCategory = (payload) => {
  return postRequest(CATEGORY_API, payload);
};